import { NotificationOfChange } from "../../models/notification-of-change";

export class GetNotificationOfChangeData {
    static notificationOfChangeData: NotificationOfChange[] = [
      {
          "DeedApplicationId": "847291",
          "ONRSRRefId": "583462",
          "DetailDescription": "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.",
          "Status": "Submitted",
          "DateProcessingStart": "2026-01-19",
          "Region": "VIC",

      },
      {
          "DeedApplicationId": "293847",
          "ONRSRRefId": "716294",
          "DetailDescription": "Pellentesque habitant morbi tristique senectus et netus et malesuada fames ac turpis egestas. Vestibulum tortor quam, feugiat vitae, ultricies eget, tempor sit amet, ante. Donec eu libero sit amet quam egestas semper. Aenean ultricies mi vitae est. Mauris placerat eleifend leo. Quisque sit amet est et sapien ullamcorper pharetra.\n\nVestibulum erat wisi, condimentum sed, commodo vitae, ornare sit amet, wisi. Aenean fermentum, elit eget tincidunt condimentum, eros ipsum rutrum orci, sagittis tempus lacus enim ac dui. Donec non enim in turpis pulvinar facilisis. Ut felis. Praesent dapibus, neque id cursus faucibus, tortor neque egestas augue, eu vulputate magna eros eu erat.",
          "Status": "Submitted",
          "DateProcessingStart": "2026-01-15",
          "Region": "VIC",

      },
      {
          "DeedApplicationId": "581936",
          "ONRSRRefId": "429187",
          "DetailDescription": "Cras mattis consectetur purus sit amet fermentum. Donec id elit non mi porta gravida at eget metus.",
          "Status": "Submitted",
          "DateProcessingStart": "2026-01-15",
          "Region": "VIC",

      },
      {
          "DeedApplicationId": "674218",
          "ONRSRRefId": "852369",
          "DetailDescription": "Fusce dapibus, tellus ac cursus commodo, tortor mauris condimentum nibh, ut fermentum massa justo sit amet risus. Maecenas sed diam eget risus varius blandit sit amet non magna. Integer posuere erat a ante venenatis dapibus posuere velit aliquet. Cras justo odio, dapibus ac facilisis in, egestas eget quam.\n\nNullam quis risus eget urna mollis ornare vel eu leo. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Nullam id dolor id nibh ultricies vehicula ut id elit.",
          "Status": "Submitted",
          "DateProcessingStart": "2026-01-15",
          "Region": "VIC",

      },
      {
          "DeedApplicationId": "192734",
          "ONRSRRefId": "648591",
          "DetailDescription": "Morbi leo risus, porta ac consectetur ac, vestibulum at eros. Praesent commodo cursus magna, vel scelerisque nisl consectetur et. Vivamus sagittis lacus vel augue laoreet rutrum faucibus dolor auctor. Duis mollis, est non commodo luctus, nisi erat porttitor ligula, eget lacinia odio sem nec elit.\n\nAenean lacinia bibendum nulla sed consectetur. Cras mattis consectetur purus sit amet fermentum. Donec ullamcorper nulla non metus auctor fringilla. Maecenas faucibus mollis interdum.\n\nEtiam porta sem malesuada magna mollis euismod. Sed posuere consectetur est at lobortis. Morbi leo risus, porta ac consectetur ac, vestibulum at eros. Nullam quis risus eget urna mollis ornare vel eu leo.",
          "Status": "Submitted",
          "DateProcessingStart": "2026-01-08",
          "Region": "VIC",

      },
      {
          "DeedApplicationId": "438562",
          "ONRSRRefId": "271845",
          "DetailDescription": "Vivamus sagittis lacus vel augue laoreet rutrum faucibus dolor auctor. Duis mollis, est non commodo luctus, nisi erat porttitor ligula, eget lacinia odio sem nec elit. Morbi leo risus, porta ac consectetur ac, vestibulum at eros.\n\nInteger posuere erat a ante venenatis dapibus posuere velit aliquet. Praesent commodo cursus magna, vel scelerisque nisl consectetur et. Donec sed odio dui. Aenean eu leo quam. Pellentesque ornare sem lacinia quam venenatis vestibulum.\n\nCras mattis consectetur purus sit amet fermentum. Cras justo odio, dapibus ac facilisis in, egestas eget quam. Donec id elit non mi porta gravida at eget metus. Nullam id dolor id nibh ultricies vehicula ut id elit.\n\nSed posuere consectetur est at lobortis. Aenean lacinia bibendum nulla sed consectetur. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus.",
          "Status": "Submitted",
          "DateProcessingStart": "2026-01-08",
          "Region": "VIC",

      },
      {
          "DeedApplicationId": "759314",
          "ONRSRRefId": "384926",
          "DetailDescription": "Nulla vitae elit libero, a pharetra augue. Nullam id dolor id nibh ultricies vehicula.",
          "Status": "Submitted",
          "DateProcessingStart": "2025-12-15",
          "Region": "VIC",

      },
      {
          "DeedApplicationId": "612847",
          "ONRSRRefId": "937561",
          "DetailDescription": "Praesent commodo cursus magna, vel scelerisque nisl consectetur et. Aenean lacinia bibendum nulla sed consectetur. Donec sed odio dui. Cras mattis consectetur purus sit amet fermentum.\n\nMaecenas faucibus mollis interdum. Donec ullamcorper nulla non metus auctor fringilla. Vestibulum id ligula porta felis euismod semper.",
          "Status": "Draft",
          "DateProcessingStart": "1900-01-01",
          "Region": "VIC",

      },
      {
          "DeedApplicationId": "346782",
          "ONRSRRefId": "518473",
          "DetailDescription": "Etiam porta sem malesuada magna mollis euismod. Aenean eu leo quam. Pellentesque ornare sem lacinia quam venenatis vestibulum. Donec id elit non mi porta gravida at eget metus.\n\nCum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Vivamus sagittis lacus vel augue laoreet rutrum faucibus dolor auctor. Cras mattis consectetur purus sit amet fermentum.",
          "Status": "Submitted",
          "DateProcessingStart": "2025-12-01",
          "Region": "VIC",

      },
      {
          "DeedApplicationId": "925148",
          "ONRSRRefId": "163829",
          "DetailDescription": "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nullam quis risus eget urna mollis ornare vel eu leo. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus.\n\nMorbi leo risus, porta ac consectetur ac, vestibulum at eros. Integer posuere erat a ante venenatis dapibus posuere velit aliquet. Duis mollis, est non commodo luctus, nisi erat porttitor ligula.\n\nFusce dapibus, tellus ac cursus commodo, tortor mauris condimentum nibh, ut fermentum massa justo sit amet risus. Vivamus sagittis lacus vel augue laoreet rutrum faucibus dolor auctor.\n\nAenean lacinia bibendum nulla sed consectetur. Cras justo odio, dapibus ac facilisis in, egestas eget quam. Donec ullamcorper nulla non metus auctor fringilla.\n\nNullam id dolor id nibh ultricies vehicula ut id elit. Praesent commodo cursus magna, vel scelerisque nisl consectetur et.",
          "Status": "Submitted",
          "DateProcessingStart": "2025-11-25",
          "Region": "VIC",

      },
      {
          "DeedApplicationId": "481593",
          "ONRSRRefId": "742618",
          "DetailDescription": "Vestibulum id ligula porta felis euismod semper. Sed posuere consectetur est at lobortis.",
          "Status": "Draft",
          "DateProcessingStart": "1900-01-01",
          "Region": "VIC",

      },
      {
          "DeedApplicationId": "267495",
          "ONRSRRefId": "891347",
          "DetailDescription": "Donec ullamcorper nulla non metus auctor fringilla. Maecenas sed diam eget risus varius blandit sit amet non magna. Cras mattis consectetur purus sit amet fermentum.\n\nNulla vitae elit libero, a pharetra augue. Aenean eu leo quam. Pellentesque ornare sem lacinia quam venenatis vestibulum. Integer posuere erat a ante venenatis dapibus posuere velit aliquet.",
          "Status": "Draft",
          "DateProcessingStart": "1900-01-01",
          "Region": "VIC",

      },
      {
          "DeedApplicationId": "538174",
          "ONRSRRefId": "629485",
          "DetailDescription": "Cras justo odio, dapibus ac facilisis in, egestas eget quam. Nullam quis risus eget urna mollis ornare vel eu leo. Morbi leo risus, porta ac consectetur ac, vestibulum at eros. Fusce dapibus, tellus ac cursus commodo, tortor mauris condimentum nibh.\n\nDonec sed odio dui. Etiam porta sem malesuada magna mollis euismod. Praesent commodo cursus magna, vel scelerisque nisl consectetur et. Vivamus sagittis lacus vel augue laoreet rutrum faucibus dolor auctor.",
          "Status": "Draft",
          "DateProcessingStart": "1900-01-01",
          "Region": "VIC",

      },
      {
          "DeedApplicationId": "894621",
          "ONRSRRefId": "352716",
          "DetailDescription": "Maecenas faucibus mollis interdum. Aenean lacinia bibendum nulla sed consectetur. Duis mollis, est non commodo luctus, nisi erat porttitor ligula, eget lacinia odio sem nec elit.\n\nCum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Donec id elit non mi porta gravida at eget metus. Nullam id dolor id nibh ultricies vehicula ut id elit.",
          "Status": "Submitted",
          "DateProcessingStart": "2025-10-22",
          "Region": "VIC",

      },
      {
          "DeedApplicationId": "173849",
          "ONRSRRefId": "485962",
          "DetailDescription": "Sed posuere consectetur est at lobortis. Vestibulum id ligula porta felis euismod semper.",
          "Status": "Draft",
          "DateProcessingStart": "1900-01-01",
          "Region": "VIC",

      },
      {
          "DeedApplicationId": "629518",
          "ONRSRRefId": "814237",
          "DetailDescription": "Integer posuere erat a ante venenatis dapibus posuere velit aliquet. Cras mattis consectetur purus sit amet fermentum. Nulla vitae elit libero, a pharetra augue.\n\nDonec ullamcorper nulla non metus auctor fringilla. Maecenas sed diam eget risus varius blandit sit amet non magna. Praesent commodo cursus magna, vel scelerisque nisl consectetur et.\n\nAenean eu leo quam. Pellentesque ornare sem lacinia quam venenatis vestibulum. Morbi leo risus, porta ac consectetur ac, vestibulum at eros.",
          "Status": "Submitted",
          "DateProcessingStart": "2025-10-21",
          "Region": "VIC",

      },
      {
          "DeedApplicationId": "748362",
          "ONRSRRefId": "291574",
          "DetailDescription": "Nullam quis risus eget urna mollis ornare vel eu leo. Vivamus sagittis lacus vel augue laoreet rutrum faucibus dolor auctor. Duis mollis, est non commodo luctus.",
          "Status": "Submitted",
          "DateProcessingStart": "2025-10-08",
          "Region": "VIC",

      },
      {
          "DeedApplicationId": "516928",
          "ONRSRRefId": "673814",
          "DetailDescription": "Fusce dapibus, tellus ac cursus commodo, tortor mauris condimentum nibh, ut fermentum massa justo sit amet risus. Cras justo odio, dapibus ac facilisis in, egestas eget quam. Etiam porta sem malesuada magna mollis euismod.\n\nAenean lacinia bibendum nulla sed consectetur. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Donec sed odio dui. Nullam id dolor id nibh ultricies vehicula ut id elit.\n\nMaecenas faucibus mollis interdum. Vestibulum id ligula porta felis euismod semper. Sed posuere consectetur est at lobortis. Praesent commodo cursus magna, vel scelerisque nisl consectetur et.\n\nInteger posuere erat a ante venenatis dapibus posuere velit aliquet. Nulla vitae elit libero, a pharetra augue. Donec ullamcorper nulla non metus auctor fringilla.",
          "Status": "Draft",
          "DateProcessingStart": "1900-01-01",
          "Region": "VIC",

      },
      {
          "DeedApplicationId": "382471",
          "ONRSRRefId": "946153",
          "DetailDescription": "Morbi leo risus, porta ac consectetur ac, vestibulum at eros. Maecenas sed diam eget risus varius blandit sit amet non magna.",
          "Status": "Submitted",
          "DateProcessingStart": "2025-08-12",
          "Region": "VIC",

      },
      {
          "DeedApplicationId": "641829",
          "ONRSRRefId": "527384",
          "DetailDescription": "Cras mattis consectetur purus sit amet fermentum. Aenean eu leo quam. Pellentesque ornare sem lacinia quam venenatis vestibulum. Duis mollis, est non commodo luctus, nisi erat porttitor ligula, eget lacinia odio sem nec elit.\n\nVivamus sagittis lacus vel augue laoreet rutrum faucibus dolor auctor. Nullam quis risus eget urna mollis ornare vel eu leo. Donec id elit non mi porta gravida at eget metus.",
          "Status": "Draft",
          "DateProcessingStart": "1900-01-01",
          "Region": "VIC",

      },
      {
          "DeedApplicationId": "957362",
          "ONRSRRefId": "418695",
          "DetailDescription": "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris.\n\nDuis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.\n\nPellentesque habitant morbi tristique senectus et netus et malesuada fames ac turpis egestas. Vestibulum tortor quam, feugiat vitae, ultricies eget, tempor sit amet, ante.",
          "Status": "Submitted",
          "DateProcessingStart": "2025-07-30",
          "Region": "VIC",

      },
      {
          "DeedApplicationId": "284619",
          "ONRSRRefId": "763542",
          "DetailDescription": "Donec eu libero sit amet quam egestas semper. Aenean ultricies mi vitae est. Mauris placerat eleifend leo.",
          "Status": "Draft",
          "DateProcessingStart": "1900-01-01",
          "Region": "VIC",

      },
      {
          "DeedApplicationId": "473281",
          "ONRSRRefId": "859417",
          "DetailDescription": "Quisque sit amet est et sapien ullamcorper pharetra. Vestibulum erat wisi, condimentum sed, commodo vitae, ornare sit amet, wisi.\n\nAenean fermentum, elit eget tincidunt condimentum, eros ipsum rutrum orci, sagittis tempus lacus enim ac dui. Donec non enim in turpis pulvinar facilisis. Ut felis.\n\nPraesent dapibus, neque id cursus faucibus, tortor neque egestas augue, eu vulputate magna eros eu erat. Aliquam erat volutpat. Nam dui mi, tincidunt quis, accumsan porttitor, facilisis luctus, metus.\n\nPhasellus ultrices nulla quis nibh. Quisque a lectus. Donec consectetuer ligula vulputate sem tristique cursus.",
          "Status": "Submitted",
          "DateProcessingStart": "2025-06-05",
          "Region": "VIC",

      },
      {
          "DeedApplicationId": "819546",
          "ONRSRRefId": "234871",
          "DetailDescription": "Nam dui mi, tincidunt quis, accumsan porttitor, facilisis luctus, metus. Phasellus ultrices nulla quis nibh. Quisque a lectus.\n\nDonec consectetuer ligula vulputate sem tristique cursus. Fusce sagittis, libero non molestie mollis, magna orci ultrices dolor, at vulputate neque nulla lacinia eros.\n\nSed convallis magna eu sem. Cras pede libero, dapibus nec, pretium sit amet, tempor quis, urna. Etiam posuere quam ac quam.\n\nMaecenas aliquet mollis lectus. Vivamus consectetuer risus et tortor. Lorem ipsum dolor sit amet, consectetur adipiscing elit. Integer nec odio. Praesent libero.\n\nSed cursus ante dapibus diam. Sed nisi. Nulla quis sem at nibh elementum imperdiet. Duis sagittis ipsum. Praesent mauris.",
          "Status": "Submitted",
          "DateProcessingStart": "2025-05-21",
          "Region": "VIC",

      },
      {
          "DeedApplicationId": "365724",
          "ONRSRRefId": "691328",
          "DetailDescription": "Fusce nec tellus sed augue semper porta. Mauris massa. Vestibulum lacinia arcu eget nulla.",
          "Status": "Submitted",
          "DateProcessingStart": "2025-05-01",
          "Region": "VIC",

      },
      {
          "DeedApplicationId": "728459",
          "ONRSRRefId": "542183",
          "DetailDescription": "Class aptent taciti sociosqu ad litora torquent per conubia nostra, per inceptos himenaeos. Curabitur sodales ligula in libero. Sed dignissim lacinia nunc.\n\nCurabitur tortor. Pellentesque nibh. Aenean quam. In scelerisque sem at dolor. Maecenas mattis. Sed convallis tristique sem.",
          "Status": "Submitted",
          "DateProcessingStart": "2025-04-22",
          "Region": "VIC",
      },
      {
          "DeedApplicationId": "593184",
          "ONRSRRefId": "817462",
          "DetailDescription": "Proin ut ligula vel nunc egestas porttitor. Morbi lectus risus, iaculis vel, suscipit quis, luctus non, massa.",
          "Status": "Submitted",
          "DateProcessingStart": "2025-04-21",
          "Region": "VIC",
      },
      {
          "DeedApplicationId": "146927",
          "ONRSRRefId": "378549",
          "DetailDescription": "Fusce ac turpis quis ligula lacinia aliquet. Mauris ipsum. Nulla metus metus, ullamcorper vel, tincidunt sed, euismod in, nibh. Quisque volutpat condimentum velit.\n\nClass aptent taciti sociosqu ad litora torquent per conubia nostra, per inceptos himenaeos. Nam nec ante. Sed lacinia, urna non tincidunt mattis, tortor neque adipiscing diam, a cursus ipsum ante quis turpis.\n\nNulla facilisi. Ut fringilla. Suspendisse potenti. Nunc feugiat mi a tellus consequat imperdiet. Vestibulum sapien. Proin quam.",
          "Status": "Submitted",
          "DateProcessingStart": "2025-04-10",
          "Region": "VIC",
      },
      {
          "DeedApplicationId": "852394",
          "ONRSRRefId": "463718",
          "DetailDescription": "Etiam ultrices. Suspendisse in justo eu magna luctus suscipit. Sed lectus. Integer euismod lacus luctus magna.\n\nQuisque cursus, metus vitae pharetra auctor, sem massa mattis sem, at interdum magna augue eget diam. Vestibulum ante ipsum primis in faucibus orci luctus et ultrices posuere cubilia Curae.",
          "Status": "Submitted",
          "DateProcessingStart": "2025-04-02",
          "Region": "VIC",
      },
      {
          "DeedApplicationId": "417863",
          "ONRSRRefId": "925634",
          "DetailDescription": "Morbi lacinia molestie dui. Praesent blandit dolor. Sed non quam. In vel mi sit amet augue congue elementum. Morbi in ipsum sit amet pede facilisis laoreet. Donec lacus nunc, viverra nec, blandit vel, egestas et, augue.\n\nVestibulum tincidunt malesuada tellus. Ut ultrices ultrices enim. Curabitur sit amet mauris. Morbi in dui quis est pulvinar ullamcorper. Nulla facilisi.\n\nInteger lacinia sollicitudin massa. Cras metus. Sed aliquet risus a tortor. Integer id quam. Morbi mi. Quisque nisl felis, venenatis tristique, dignissim in, ultrices sit amet, augue. Proin sodales libero eget ante.",
          "Status": "Submitted",
          "DateProcessingStart": "2025-04-02",
          "Region": "VIC",
      }
  ];
}
